import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { DetailLoading } from "~/components/loading";
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "~/components/ui";
import { DataImportProjectsModelProvider } from "~/features/dataImportProjects/context";
import { GetDataImportProjectsWithReferencesDocument } from "~/features/dataImportProjects/gqls";
import { useTenant } from "~/features/tenant/context";
import {
  BOOTSTRAP_DATA_IMPORT_PROJECT_FORM_ID,
  BootstrapDataImportProjectForm,
} from "./BootstrapDataImportProjectForm";

interface DataImportProjectBootstrapDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DataImportProjectBootstrapDialog({ open, onOpenChange }: DataImportProjectBootstrapDialogProps) {
  const { t } = useTranslation();
  const { tenantId } = useTenant();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {t("ui.bootstrap")} {t("model.dataImportProject.modelName")} ({t("ui.deprecated")})
          </DialogTitle>
        </DialogHeader>
        <Suspense fallback={<DetailLoading className="py-4" />}>
          {open && (
            <DataImportProjectsModelProvider>
              <BootstrapDataImportProjectForm
                onSubmit={() => onOpenChange(false)}
                refetchQueriesOnBootstrap={[
                  { query: GetDataImportProjectsWithReferencesDocument, variables: { tenantId } },
                ]}
              />
            </DataImportProjectsModelProvider>
          )}
        </Suspense>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {t("ui.cancel")}
          </Button>
          <Button type="submit" form={BOOTSTRAP_DATA_IMPORT_PROJECT_FORM_ID}>
            {t("ui.bootstrap")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
